export default __webpack_public_path__ + "static/media/element_27.1af68714.jpg";